module.exports = __webpack_public_path__ + "img/searchbig.9d251bc3.svg";